import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, KeyRound, BedDouble, Camera, ArrowUpRight, MapPin } from "lucide-react";
import Reveal from "./Reveal";
import { LogoTitle } from "./Common";
import { SERVICE_PAGES, SERVICE_CITIES, nearestCities } from "../../seo";
import { aCity, slugify } from "../../mock";

export const SVC_ICONS = { sparkles: Sparkles, key: KeyRound, bed: BedDouble, camera: Camera };
const isServiceCity = (name) => SERVICE_CITIES.some((c) => c.name === name);

function ServiceCard({ city, svc, i }) {
  const I = SVC_ICONS[svc.icon];
  return (
    <Reveal delay={i * 70}>
      <Link to={`/villes/${slugify(city.name)}/${svc.slug}`} data-testid={`svc-link-${svc.slug}`} className="group flex h-full flex-col rounded-3xl bg-white ring-1 ring-[#e6dcc8] hover:ring-[#d9895a] p-6 transition-shadow">
        <span className="w-11 h-11 rounded-2xl bg-[#f6e3d5] grid place-items-center"><I className="w-5 h-5 text-[#c4703f]" /></span>
        <span className="mt-4 font-bold text-lg text-[#13261c]">{svc.name} {city.name}</span>
        <span className="mt-1.5 text-[15px] text-[#5a6158] leading-relaxed">{svc.short(aCity(city.name))}</span>
        <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#c4703f]">En savoir plus<ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" /></span>
      </Link>
    </Reveal>
  );
}

export function CityServices({ city, exclude }) {
  if (!isServiceCity(city.name)) return null;
  const list = SERVICE_PAGES.filter((s) => s.slug !== exclude);
  return (
    <section className="pb-20" data-testid="city-services">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal><LogoTitle as="h2" size="md" title={exclude ? "nos autres services" : "nos services"} script={aCity(city.name)} /></Reveal>
        <div className={`mt-10 grid sm:grid-cols-2 gap-4 ${list.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
          {list.map((s, i) => <ServiceCard key={s.slug} city={city} svc={s} i={i} />)}
        </div>
      </div>
    </section>
  );
}

export function ServiceOtherCities({ city, svc }) {
  return (
    <section className="pb-20" data-testid="svc-other-cities">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h2 className="font-logo font-black tracking-[-0.025em] text-3xl lg:text-4xl text-[#13261c]">{svc.name.toLowerCase().replace("airbnb", "Airbnb")} dans les communes voisines</h2>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {nearestCities(city.name, 9).map((c) => (
            <Link key={c.name} to={`/villes/${slugify(c.name)}/${svc.slug}`} data-testid={`svc-city-${slugify(c.name)}`} className="group flex items-center justify-between rounded-2xl p-5 ring-1 ring-[#e6dcc8] bg-white hover:bg-[#13261c] hover:text-white text-[#13261c] transition-colors">
              <span className="flex items-center gap-3 font-bold"><MapPin className="w-5 h-5 text-[#c4703f] group-hover:text-[#d9895a]" />{svc.name} {c.name}</span>
              <span className="shrink-0 whitespace-nowrap text-sm text-[#c4703f] group-hover:text-[#d9895a]">{c.km} km</span>
              <ArrowUpRight className="w-5 h-5 opacity-40 group-hover:opacity-100 transition-opacity" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
